import { DevicesPage } from './DevicesPage';
export default DevicesPage;
